import { useReducer } from "react";
// src/hooks/useToggle.ts
function useToggle(initialValue = false) {
	return useReducer((state) => !state, initialValue);
}
export { useToggle };

//# sourceMappingURL=useToggle.js.map